<template>
    <div class="body">
        <div class="popup">
            <div class="t-c">
                <img src="@/assets/dzp/t_h.png" alt="">
            </div>
            <van-field  v-model="iccid"  name="mobile"  label="号码："  placeholder="请输入你要激活的号码"  :rules="[{ required: true, message: '请输入你要激活的号码' }]" />
            <van-button class="bu_tn" round block type="info" native-type="submit" @click="onSubmit">确认</van-button>
        </div>
    </div> 
</template>
<script>
import {Dialog} from "vant";
import {Toast} from "vant";
import {wxRequest} from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
    data(){
        return{
            code:'',
            iccid:''
        }
    },
     created() {
      var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
        localStorage.setItem('appid', source);
        localStorage.setItem('isHeadquarterAppid', false);
        var appid  = source ? source : process.env.VUE_APP_APPID;

    console.log(appid);
    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      this.iccid = localStorage.getItem("recordLoginText");

      //自动登录
      // if(this.iccid){
      //     this.userQuerySIM();
      // }
    }
    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);
  },
    methods:{
          //获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
        onSubmit(){
            let recordLoginText = this.iccid; 
            let data = {
        requestId: this.iccid,
        code: this.code,
        app:'13123123'
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          localStorage.setItem("isCode", true);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("ishavePkg", record.ishavePkg);
         localStorage.setItem("ishavePrice", record.ishavePrice);
          localStorage.setItem("iccid", record.iccid);
          localStorage.setItem("openId",record.openId);
          localStorage.setItem("virtualNo",record.virtualNo);
          localStorage.setItem("priceImgUrl",record.priceImgUrl);

          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
           this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);

          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);
          //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          let cardType = record.supplierTypeCode;
          let _data = {
              requestId:iccid,
              code:this.code
          };
          if(record.isSale==1&&record.ishavePrice==0){
             this.$router.replace('/user/simOpen');
          }else  if(record.isSale==2&&record.ishavePrice==0){
             this.$router.replace('/user/simOpen100');
          }else  if(record.isSale==3&&record.ishavePrice==0){
             this.$router.replace('/user/simOpen20');
          }else  if(record.isSale==4&&record.ishavePrice==0){
             this.$router.replace('/user/simOpenYx');
          }else if (record.isBind == 1) {
            this.$router.push({
              path: "/user/bindPhone1",
              query: {
                iccid: record.iccid,
              },
            });
          } else if (record.isBind == 2) {
            this.$router.push({
              path: "/user/bindPhone",
              query: {
                iccid: record.iccid,
              },
            });
          }else{
             this.$router.replace('/user/home');
          }
        } else {
          Dialog.alert({title: "提示", message: res.data.message});
        }
      });
        }
    }
}
</script>
<style lang="less" scoped>
.body{
    background: url('../../assets/dzp/659841b5.png')no-repeat center;
    background-size: 100% 100%;
    width:100%;
    height:100%;
    position: relative;
    .popup{
        background: linear-gradient(0deg,#ffe1b1,#fff);
        box-sizing: border-box;
        padding: 25px 0;
        width: 325px;
        position: fixed;
        left: 0;
        right: 0;
        margin: auto;
        top: 25%;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        box-shadow:0 6px 6px 0 rgb(219 0 0 / 75%);
        .t-c{
            height:60px;
            text-align: center;
            img{
                height:100%;
            }
        }
        .van-cell{
            height:50px;
            width: 275px;
            border-radius: 17px;
            border: 2px solid #000;
            padding-left: 10px;
            background: none;
            margin: auto;
            margin-top: 20px;
            ::v-deep .van-cell__title{
                width:50px;
            }
        }
        .bu_tn{
            height: 50px;
            line-height: 50px;
            text-align: center;
            width: 275px;
            color: #fff;
            background: #f43604;
            border-radius: 17px;
            margin:auto;
            margin-top: 20px;
            border:1px solid #f43604;
        }
    }
}
</style>